<template>
  <div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  created() {
    this.$router.replace({
      path: this.$route.params.newPath
    })
  }
}
</script>
<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/blank/blank.vue